/* Product Card Enhanced JavaScript - alcfree.ch */
/* Handles quantity selector and AJAX add to cart */
/* Version 2: Using FormData and string IDs for large variant numbers */

(function() {
  'use strict';

  // Make function globally available
  window.alcfreeAddToCart = function(btn) {
    // Get variant ID as string (important for large numbers)
    var variantId = btn.getAttribute('data-variant-id');
    var card = btn.closest('.card-add-to-cart');
    var quantityInput = card ? card.querySelector('.qty-input') : null;
    var quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;

    // Debug alert - shows what we're sending
    // alert('DEBUG: Variant=' + variantId + ', Qty=' + quantity);

    if (!variantId) {
      alert('Fehler: Keine Produkt-ID gefunden');
      return;
    }

    if (btn.classList.contains('loading')) {
      return;
    }

    btn.classList.add('loading');

    // Use FormData - more reliable with Shopify
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      btn.classList.remove('loading');

      // Check for error response
      if (data.status && data.status === 422) {
        alert('Fehler: ' + (data.description || 'Konnte nicht hinzugefuegt werden'));
        return;
      }

      // Success
      if (data.title || data.id) {
        btn.classList.add('success');

        // Show success notification
        var notification = document.createElement('div');
        notification.className = 'cart-notification';
        notification.textContent = quantity + 'x zum Warenkorb hinzugefuegt!';
        document.body.appendChild(notification);

        setTimeout(function() {
          notification.style.opacity = '0';
          setTimeout(function() { notification.remove(); }, 300);
        }, 2500);

        // Update cart count
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            // Dawn theme cart bubble
            var bubble = document.querySelector('.cart-count-bubble');
            if (bubble) {
              var span = bubble.querySelector('span[aria-hidden]');
              if (span) span.textContent = cart.item_count;
              bubble.classList.add('cart-pulse');
              setTimeout(function() { bubble.classList.remove('cart-pulse'); }, 300);
            }
            // Other common selectors
            document.querySelectorAll('[data-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
            });
          });

        setTimeout(function() {
          btn.classList.remove('success');
        }, 1500);
      } else {
        // Unexpected response
        alert('Unerwartete Antwort vom Server');
      }
    })
    .catch(function(error) {
      btn.classList.remove('loading');
      alert('Netzwerk-Fehler: ' + error.message);
    });
  };

})();
